/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */

import {ButtonRestDto} from ".";
import {ContentBlockMetadataRestDto} from ".";
import {MultilingualFieldRestDto} from ".";
import {MultilingualMax500FieldRestDto} from ".";
import {SymbolRestDto} from ".";
import {TitleMetaDataRestDto} from ".";
import {ButtonHorizontalPositionEnum} from "@/api/enums/button-horizontal-position-enum";
import {StatusEnum} from "@/api/enums/status-enum";
import {TextWithImageContentBlockLayoutEnum} from "@/api/enums/text-with-image-content-block-layout-enum";
import {TitleSizeEnum} from "@/api/enums/title-size-enum";

/**
 * @export
 * @interface TextWithSymbolContentRestDto
 */
export interface TextWithSymbolContentRestDto {
    /**
     * The status of this content block.
     * @type {StatusEnum}
     * @memberof TextWithSymbolContentRestDto
     */
    status_code: StatusEnum;

    /**
     * The sorting value of this content block.
     * @type {number|null}
     * @memberof TextWithSymbolContentRestDto
     */
    sort_weight?: number|null;

    /**
     * Determines the layout of this content block.
     * @type {TextWithImageContentBlockLayoutEnum|null}
     * @memberof TextWithSymbolContentRestDto
     */
    layout_code?: TextWithImageContentBlockLayoutEnum|null;

    /**
     * 
     * @type {MultilingualMax500FieldRestDto|null}
     * @memberof TextWithSymbolContentRestDto
     */
    title?: MultilingualMax500FieldRestDto|null;

    /**
     * Determines the size of the title.
     * @type {TitleSizeEnum|null}
     * @memberof TextWithSymbolContentRestDto
     */
    title_size_code?: TitleSizeEnum|null;

    /**
     * 
     * @type {TitleMetaDataRestDto|null}
     * @memberof TextWithSymbolContentRestDto
     */
    title_meta?: TitleMetaDataRestDto|null;

    /**
     * 
     * @type {MultilingualFieldRestDto|null}
     * @memberof TextWithSymbolContentRestDto
     */
    content?: MultilingualFieldRestDto|null;

    /**
     * 
     * @type {SymbolRestDto|null}
     * @memberof TextWithSymbolContentRestDto
     */
    symbol?: SymbolRestDto|null;

    /**
     * 
     * @type {ButtonRestDto|null}
     * @memberof TextWithSymbolContentRestDto
     */
    button?: ButtonRestDto|null;

    /**
     * Determines the horizontal object-position for the button.
     * @type {ButtonHorizontalPositionEnum|null}
     * @memberof TextWithSymbolContentRestDto
     */
    button_horizontal_position_code?: ButtonHorizontalPositionEnum|null;

    /**
     * 
     * @type {ContentBlockMetadataRestDto|null}
     * @memberof TextWithSymbolContentRestDto
     */
    cb_metadata?: ContentBlockMetadataRestDto|null;

}

/**
 * @export
 * @function cloneTextWithSymbolContentRestDtoMetaData
 */
export function cloneTextWithSymbolContentRestDtoMetaData(dto: TextWithSymbolContentRestDto, source: TextWithSymbolContentRestDto): void {
    dto.layout_code = source.layout_code;
    dto.title_size_code = source.title_size_code;
}
